const roles = {
    CLIENT_CONTACT_PERSON: 'CLIENT_CONTACT_PERSON',
    PROJECT_COORDINATOR: 'PROJECT_COORDINATOR',
    SUPERVISOR: 'SUPERVISOR',
};

export default roles;
